import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'


export function login(data) {
    return request({
        url: "/spreader/user/login",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function tellogin(data) {
    return request({
        url: "/spreader/user/tellogin",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function register(data) {
    return request({
        url: "/spreader/user/register",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}


// WEBPACK FOOTER //
// ./src/api/spreader/login.js